{
  "seoTitle": "Work",
  "seoDescription": "Explore Leah Harding's event moderation, international reporting, on-air work, speaking and award-nominated journalism.",
  "heroImage": "/assets/site/leah-harding-antarctica-afc2be52.jpg",
  "hero": {
    "kicker": "Selected work",
    "headingLines": [
      "On stage.",
      "On air."
    ],
    "headingAccent": "On the ground.",
    "intro": "Reporting with urgency. Moderating with intention. Hosting with the kind of curiosity that invites people to say what they actually mean."
  },
  "video": {
    "sectionNumber": "From the archive",
    "heading": "Watch Leah at work.",
    "youtubeLabel": "More on YouTube",
    "youtubeHref": "https://www.youtube.com/channel/UCZkh--IdttAuwurLYNCR1rA"
  },
  "items": [
    {
      "title": "Podcast Launch",
      "eyebrow": "Now streaming",
      "image": "/assets/site/leahharding-31967229.png",
      "text": "After calling off her engagement, Leah realized just how disconnected she had become from herself. In Disengaged, she and her guests explore self-advocacy, leadership and what trusting your gut can look like."
    },
    {
      "title": "Master’s Degree",
      "eyebrow": "Syracuse University",
      "image": "/assets/site/96ce2588-b543-4b5e-9d13-cc75d485e8c5-19585c29.jpg",
      "text": "In 2024, Leah earned a Master of Arts in Public Diplomacy and Global Communications from Syracuse University, along with a certificate in National Security Studies."
    },
    {
      "title": "Amazon to Antarctica",
      "eyebrow": "Climate reporting",
      "image": "/assets/site/leah-harding-antarctica-afc2be52.jpg",
      "text": "Leah sailed from the heart of the Amazon rainforest to Antarctica on a 37-day voyage, reporting on endangered river dolphins, bird flu in the Falkland Islands and eco-tourism on the White Continent."
    },
    {
      "title": "Qatar FIFA World Cup",
      "eyebrow": "Investigative reporting",
      "image": "/assets/site/leah-harding-doha-6aa41a84.jpg",
      "text": "Leah and her team investigated human rights and labor concerns around the first FIFA World Cup hosted by an Arab nation, ensuring those stories were not overshadowed by the fanfare."
    },
    {
      "title": "Sports Reporting",
      "eyebrow": "On air",
      "image": "/assets/site/leah-harding-interview-8a641fc5.jpg",
      "text": "A 2018 assignment at the World Gymnastics Championships became more than a year as a sports presenter on Al Jazeera before Leah returned to the Newshours as a senior producer."
    },
    {
      "title": "Paragliding Championships",
      "eyebrow": "North Macedonia",
      "image": "/assets/site/leah-harding-reporting-5a516059.jpg",
      "text": "Leah was the only international correspondent to cover the 2019 World Paragliding Championships, one of the few sports where men and women compete against each other."
    },
    {
      "title": "Northwestern Collaboration",
      "eyebrow": "Media research",
      "image": "/assets/site/leah-harding-middle-east-7701eb34.jpg",
      "text": "In partnership with Northwestern University in Qatar, Leah wrote and presented commentary on media use in the Middle East and reporting during the blockade of Qatar."
    },
    {
      "title": "Ethiopia Unrest",
      "eyebrow": "Breaking news",
      "image": "/assets/site/leah-harding-ethiopia-cccab7b1.jpg",
      "text": "Leah was on assignment in Addis Ababa when a coup attempt began. Al Jazeera was the first network to go live from inside Ethiopia and report the deaths of top military officials."
    },
    {
      "title": "Qatar Ultramarathon",
      "eyebrow": "90 km in one day",
      "image": "/assets/site/leah-harding-ultramarathon-2-8d0249c8.jpg",
      "text": "Leah joined the first all-female team to run 90 kilometers across Qatar in one day, raising support for Free to Run and women pursuing adventure sports in conflict zones."
    },
    {
      "title": "Emmy Nomination",
      "eyebrow": "International Emmy Awards",
      "image": "/assets/site/leah-harding-emmy-f2c5bcaa.jpg",
      "text": "An episode of NewsGrid co-hosted by Leah was nominated in the News category for its reporting and analysis on the Qatar-Gulf crisis and demands to close Al Jazeera."
    }
  ],
  "clips": [
    {
      "title": "U.S. Withdrawal from Afghanistan",
      "youtubeId": "-oyxSfkflDc",
      "description": "Taliban officials ordered female TV presenters to cover their faces while on air—part of a growing crackdown on women showing their faces in public."
    },
    {
      "title": "Would You Jump?",
      "youtubeId": "zuhA6cEHvfo",
      "description": "Leah skydives with some of the world’s best military parachuting teams. Her cameraman had the challenge of catching it all from 10,000 feet—with audio."
    },
    {
      "title": "Qatar World Cup 2022",
      "youtubeId": "MbpYBSpCjjU",
      "description": "Doha built the world's first fully reusable FIFA World Cup stadium. Leah was there when some of the first containers arrived."
    },
    {
      "title": "Covid Heroes",
      "youtubeId": "JkLqnXXvko8",
      "description": "Behind the coronavirus outbreak in China, thousands of nurses—primarily women—endured tremendous sacrifices."
    },
    {
      "title": "Ethiopia Coup Attempt",
      "youtubeId": "mSB73B3lWyE",
      "description": "Leah was the first international correspondent to go live in Ethiopia during the 2019 attempted coup."
    },
    {
      "title": "Ultimate Nomad",
      "description": "Meet Thor, the first person to visit every country in the world without getting on an airplane or returning home. Leah met him during his stop in Qatar."
    }
  ]
}
